<template>
  <div>
    <section  class="navbarsection" style="margin-top: -80px;">
      <div class="txtdata">
        <h1  style="padding-top: 200px;"></h1>
      </div>
        <div class="videosection" >
          <div  v-show="pvisvideo === true && pvpictureimage === false ">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.98
                :src="src"
                :poster="poster"
                :class="`thing playercss`"
                :style="`height: 600px;`">
              </video-background>
            </Transition>
          </div>
        
            <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px; z-index: 1;`">
            </div>
  
            <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
            v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
   
      </div>
      <div class="overlay"></div>
      <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px; ">
        <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
      </div>
    </section>


    <StockCards :getstocks="getstocks" stocktheme="stockcss" />


   
    <RelMinerals :allyears="allyears" :yearimages="yearimages" @getId="logChange" :getlastimage="getlastimage" :showImage="showImage" pantheme='pantopsection'/>

    <ContainerFluid :contfluiddata="contfluiddata" />


    <AllcardsSection :allcardsdata="allcardsdata"/>
    <section style="height: 40px;">
    </section>

    <ContSection :contdata="contdata" contdatatheme="contdatacss" />

    <section style="height: 40px;">
    </section>

    <section>
      <div class="container bottompagemsg">
        <hr class="hrclass"/>
        <span v-html="aboutgeneral.pdesc" class="hrspantext">
        </span>
      </div>
    </section>
    <section style="height: 40px;">
    </section>
  </div>
</template>

<script>
import StockCards from '@/components/StockCards.vue';
import RelMinerals from '@/components/RelMinerals.vue';
import ContainerFluid from '@/components/ContainerFluid.vue';
import ContSection from '@/components/ContSection.vue';
import AllcardsSection from '@/components/AllcardsSection.vue';

require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import axios from 'axios';
require('@/globalDeclare');


export default {
  name: 'AboutView',
  components: {
 StockCards, RelMinerals, ContainerFluid, ContSection, AllcardsSection,
},
data() {
  return {
    carouselSlides: [],
    videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  pictureimage: '',
  picurl: myUrlPath,

  getstocks: [],
  allyears: [],
  yearimages: [],
  contfluiddata: [],
  allcardsdata: [],
  contdata: [],
  aboutgeneral: [],
  
  histsearchid: 0,
  getlastimage: '',
  showImage: false,
  publicPath: window.location.origin
  }
},
methods: {
  logChange(event) {
    this.showImage = true
    this.histsearchid = event
    
    //------------Homepage Stock Prices---------------
    axios.get(`gethistorydataid/${this.histsearchid}`).then(
      response => {
          this.yearimages = response.data
    })
    .catch((error) => {
        console.log(error)
      })
}
},
mounted() {
  let showImage = Boolean
  console.log(this.picurl)
  showImage = false
  axios.get('allpagespv/aboutoverview').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })


  
    //------------Homepage Stock Prices---------------
    axios.get('stockprices/aboutoverview').then(
      response => {
          this.getstocks = response.data
    })
    .catch((error) => {
        console.log(error)
      })

    //------------Homepage Stock Prices---------------
    axios.get('getallhistorydata/').then(
      response => {
          this.allyears = response.data
          this.getlastimage = this.allyears[this.allyears.length - 1]
          console.log(this.getlastimage)
    })
    .catch((error) => {
        console.log(error)
      })
      
    //------------Homepage Stock Prices---------------
    axios.get('abouthistorysinglerecord/').then(
      response => {
          this.getlastimage = response.data
          this.getlastimage = response.data.abouthistimage
    })
    .catch((error) => {
        console.log(error)
      })

       
    //------------Container Fluid Section---------------
    axios.get('getcontainerfluiddata/aboutoverview').then(
      response => {
          this.contfluiddata = response.data
    })
    .catch((error) => {
        console.log(error)
      })

      //------------Container Section---------------
  axios.get('getcontainerdata/aboutoverview').then(
      response => {
          this.contdata = response.data
    })
    .catch((error) => {
        console.log(error)
      })
  //------------All Cards Section---------------
  axios.get('getallcardsectionsdata/aboutoverview').then(
      response => {
          this.allcardsdata = response.data
    })
    .catch((error) => {
        console.log(error)
      })
  //------------All Cards Section---------------
  axios.get('aboutpagegeneral/aboutoverview').then(
    response => {
        this.aboutgeneral = response.data
  })
  .catch((error) => {
      console.log(error)
    })
      
}
}
</script>

<style scoped>
.stockcards {
  padding-top: 200px;
}

.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.yearscontainer {
  background-color: grey;
  margin-top: -200px;
 }
.yearscontainergifbtm {
  margin-bottom: 20px;
}
.bottompagemsg{
  font-size: 18px;
  text-align: justify;
  border-top: solid thin grey;
}
.hrspantext {
  padding-top: 10px;
}
.stockcss {
  margin-top: 100px;
  width: 70%;
}
.stockcss1 {
  margin-top: -190px;
  width: 70%;
}
.contdatacss {
  background-color: rgb(247, 243, 243);
  padding-top: 100px;
  padding-bottom: 100px;
}

.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  min-width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.99;
}

/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .bottompagemsg{
    margin-bottom: -350px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }

  .stockcss {
    width: 98%;
    margin-top: 100px;
    margin: 0 auto;
    padding: 20px;   
    }
  .stockcss1 {
    width: 100%;
    padding: 20px; 
  }
  .pantopsection {
    margin-top: 100px;
   }
}

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .bottompagemsg{
    margin-bottom: -200px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .stockcss {
    width: 98%;
    margin-top: 100px;
    margin: 0 auto;
    padding: 20px;   
    }
  .pantopsection {
    margin-top: 100px;
   }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .bottompagemsg{
    margin-bottom: -200px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
 
 
  .pantopsection {
    margin-top: 250px;
   }
 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .panimagesize {
    margin-top: 130px;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: 100px;
  }
 } 

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
  .stockcss {
    width: 68%;
    margin-top: 200px;
    margin: 0 auto;
    padding: 20px;   
    }
  .pantopsection {
    margin-top: 100px;
   }
  } 

</style>
